import { useCallback } from "react";
import { useDispatch } from "react-redux";
import { API, Schemas, LingoApiResponse } from "@thenounproject/lingo-core";
import * as actionTypes from "../actions/actionTypes";

const { CALL_API } = API;

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const fetchUser = (): any => {
  return {
    [CALL_API]: {
      types: [
        actionTypes.FETCH_USER,
        actionTypes.FETCH_USER_SUCCESS,
        actionTypes.FETCH_USER_FAILURE,
      ],
      endpoint: "me/?spaces=true",
      schema: Schemas.USER,
    },
  };
};

export default function () {
  const dispatch = useDispatch();
  return useCallback(() => {
    return dispatch(fetchUser()) as unknown as Promise<LingoApiResponse>;
  }, [dispatch]);
}
